import React, { forwardRef } from "react";
import moment from "moment";
import "moment-duration-format";
import { usePaceTimerDownload } from "../../../components/shared/PaceTimer/usePaceTimerDownload";
import PaceTimerButtons from "../../../components/shared/PaceTimer/PaceTimerButtons";

import station_icon from "../../../assets/images/station-icon.png";
import station_icon_noselect from "../../../assets/images/station-icon-noSeleted.png";

import wristband_img2 from "../../../assets/images/wristband_img2.png";
import wristband_sticky from "../../../assets/images/wristband_sticky.jpg";

import main_logo_navyBlue from "../../../assets/images/main-logo-navyBlue.png";

function HalfTimer(props) {
    const {
        handleHydrationStationsChange_half,
        results_half,
        raceTime,
        handleShowMap,
        showYoutubeVideo,
        chrckInput,
    } = props;

    // 使用共用的下載 hook
    const { printableRef, handleDownloadImage } = usePaceTimerDownload({
        checkInput: chrckInput,
        filename: "喵喵問個痛台北馬配速手環_半馬_4x6.jpg",
        shareTrackingEvent: "2025台北馬拉松-分享配速手環-半馬",
        downloadTrackingEvent: "2025台北馬拉松-下載配速手環-半馬",
    });

    const calculateIntervalDistance = (index) => (index + 1) * 2.5;
    const calculateDisplayDistance = (index, isLastInterval) =>
        isLastInterval ? "終點" : calculateIntervalDistance(index);

    return (
        <div className="timer-result-wrap">
            <HalfTimerPrintable
                ref={printableRef}
                results_half={results_half}
                raceTime={raceTime}
                handleHydrationStationsChange_half={handleHydrationStationsChange_half}
                calculateDisplayDistance={calculateDisplayDistance}
            />
            <div className="pace-result">
                <table className="pace-table-half">
                    <thead>
                        <tr>
                            <th scope="col">距離</th>
                            <th scope="col">停秒</th>
                            <th scope="col">離站時間</th>
                            <th scope="col">配速</th>
                            <th scope="col">注意事項</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results_half.note.map((time, index) => {
                            const isLastInterval = index === results_half.note.length - 1;
                            return (
                                <tr key={index}>
                                    <td>{calculateDisplayDistance(index, isLastInterval)}</td>
                                    <td>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                flexWrap: "nowrap",
                                            }}
                                        >
                                            <img
                                                className="stationWater-icon"
                                                src={
                                                    results_half.hydrationStations[index]
                                                        ? station_icon
                                                        : station_icon_noselect
                                                }
                                                alt={
                                                    results_half.hydrationStations[index]
                                                        ? "Checked"
                                                        : "Unchecked"
                                                }
                                                onClick={(e) =>
                                                    handleHydrationStationsChange_half(e, index)
                                                }
                                            />
                                            <span>
                                                {results_half.hydrationStations[index]
                                                    ? raceTime.hydrationTime
                                                    : ""}
                                            </span>
                                        </div>
                                    </td>
                                    <td>{results_half.formattedCumulativeTimes_half[index]}</td>
                                    <td>{results_half.formattedZoneTimes_half[index]}</td>
                                    <td>{results_half.note[index]}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <PaceTimerButtons
                    onDownload={handleDownloadImage}
                    onShowMap={handleShowMap}
                    onShowVideo={showYoutubeVideo}
                    mapTrackingEvent="2025台北馬拉松-賽道地圖-半馬"
                    videoTrackingEvent="2025台北馬拉松-賽道影片-半馬"
                />
            </div>
        </div>
    );
}

const HalfTimerPrintable = forwardRef((props, ref) => {
    const { results_half, raceTime, handleHydrationStationsChange_half, calculateDisplayDistance } =
        props;

    return (
        <div className="printable full-timer" ref={ref}>
            <div className="print-container">
                <div className="print-ring">
                    <p className="ring-title">2025台北馬拉松配速</p>
                    <table className="pace-table-half-input">
                        <thead>
                            <tr>
                                <th scope="col">距離</th>
                                <th scope="col">停秒</th>
                                <th scope="col">離站時間</th>
                                <th scope="col">配速</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results_half.note.map((time, index) => {
                                const isLastInterval = index === results_half.note.length - 1;

                                return (
                                    <tr key={index}>
                                        <td>{calculateDisplayDistance(index, isLastInterval)}</td>

                                        <td>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    marginLeft: "15px",
                                                    gap: "4px",
                                                    flexWrap: "nowrap",
                                                }}
                                            >
                                                <img
                                                    className="stationWater-icon"
                                                    src={
                                                        results_half.hydrationStations[index]
                                                            ? station_icon
                                                            : station_icon_noselect
                                                    }
                                                    alt={
                                                        results_half.hydrationStations[index]
                                                            ? "Checked"
                                                            : "Unchecked"
                                                    }
                                                    onClick={(e) =>
                                                        handleHydrationStationsChange_half(e, index)
                                                    }
                                                />
                                                <span>
                                                    {results_half.hydrationStations[index]
                                                        ? raceTime.hydrationTime
                                                        : ""}
                                                </span>
                                            </div>
                                        </td>

                                        <td>
                                            {moment(
                                                results_half.formattedCumulativeTimes_half[index],
                                                "HH:mm:ss"
                                            ).format("H:mm:ss")}
                                        </td>
                                        <td>{results_half.formattedZoneTimes_half[index]}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <img className="print-fish" src={main_logo_navyBlue} alt="手環黏貼處樣式" />
                    <img className="print-fish" src={main_logo_navyBlue} alt="手環黏貼處樣式" />
                    <img className="print-fish" src={main_logo_navyBlue} alt="手環黏貼處樣式" />
                    <img className="print-fish" src={main_logo_navyBlue} alt="手環黏貼處樣式" />
                </div>
                <div className="diy-sub-card-wrap">
                    <img
                        className="diy-sub-card"
                        src={wristband_img2}
                        alt="DIY娘娘玉手示意圖-正面"
                    />
                    <p>⬆️ 完賽祝福御守 </p>
                    <p>延長配速手環用 ⬇️</p>
                    <img src={wristband_sticky} alt="DIY娘娘玉手示意圖-黏貼區" />
                </div>
            </div>
        </div>
    );
});

export default HalfTimer;
